<script>
export default {
  components: {},
  props: ["component", "handler"],
  data: function () {
    return {};
  },
  computed: {
    noEvent: function () {
      return Object.values(this.component.projects).length == 0;
    },
  },
};
</script>

<template>
  <div class="home24-open" :class="{ noEvent }">
    <div class="home24-open-top">
      <span class="title"
        ><f-icon icon="fa6-bars-staggered"></f-icon>{{ $vt('Events') }}</span
      >
      <span class="actions" v-if="!noEvent">
        <vue-placeholder
          :component="component.create"
          :handler="handler"
        ></vue-placeholder>
      </span>
    </div>
    <div class="home24-open-center">
      <span class="no-event-new" v-if="noEvent">
        <vue-placeholder
          :component="component.create"
          :handler="handler"
        ></vue-placeholder>
      </span>
      <f-sexy-scroll v-if="!noEvent">
        <a
          :href="project.url"
          class="home24-open-project"
          v-for="project in component.projects"
          :key="project['#id']"
        >
          <span class="icon" :class="project.icon"> </span>
          <span class="title">{{ project.title }}</span>
          <span v-if="project.running" class="badge badge-running"
            >{{ $vt('Running') }}</span
          >
          <span
            v-if="project.active && !project.running"
            class="badge badge-active"
            >{{ $vt('Opened') }}</span
          >
          <span class="date">{{
            (project.date * 1000) | angularFilter("dd/MM/yyyy", "date")
          }}</span>
          <f-button type="primary icon" :href="project.url" class="link"
            ><f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </a>
      </f-sexy-scroll>
    </div>
    <div class="home24-open-bottom" v-if="!noEvent">
      <f-link type="tertiary" href="#/open"
        >{{ $vt('All Events') }} <f-icon icon="fa6-arrow-right"></f-icon
      ></f-link>
    </div>
  </div>
</template>

<style lang="scss">
.home24-open {
  height: 300px;
  display: flex;
  border-radius: 8px;
  background-color: var(--black);
  flex-direction: column;
  .home24-open-top {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    width: 100%;
    border-bottom: 1px solid var(--white-a5);
    height: 66px;
    flex: 0 0 66px;
    > .title {
      display: flex;
      gap: 8px;
      color: var(--white-a75);
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
      .f-icon {
        font-size: 20px;
        color: var(--primary);
      }
    }
    > .actions {
      margin-left: auto;
      > .f-icon {
        font-size: 22px;
      }
    }
  }
  &.noEvent {
    .home24-open-center {
      align-items: center;
      justify-content: center;
    }
  }
  .home24-open-center {
    flex: 1 1 auto;
    padding: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 8px;
    height: 0;
    .home24-open-project {
      display: flex;
      gap: 8px;
      padding: 9px 8px;
      align-items: center;
      width: 100%;
      border-radius: 6px;
      cursor: pointer;

      > .f-button {
        opacity: 0;
      }

      &:hover {
        background-color: var(--white-a5);
        > .f-button {
          opacity: 1;
        }
      }

      > .icon {
        margin-right: 4px;
        flex: 0 0 26px;
        height: 26px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

        &.conference {
          background-image: url("/vodalys/vfigma/assets/conference_turquoise.svg");
        }

        &.production {
          background-image: url("/vodalys/vfigma/assets/production_turquoise.svg");
        }

        &.player {
          background-image: url("/vodalys/vfigma/assets/player_turquoise.svg");
        }

        &.all-in-one,
        &.allinone,
        &.event {
          background-image: url("/vodalys/vfigma/assets/event.svg");
        }

        &.studio {
          background-image: url("/vodalys/vfigma/assets/production_turquoise.svg");
        }

        &.player {
          background-image: url("/vodalys/vfigma/assets/player_turquoise.svg");
        }
      }

      > a.icon {
        flex: 0 0 32px;
        height: 32px;
      }

      > .title {
        font-weight: 700;
        color: var(--white-a75);
        font-size: 14px;
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .badge {
        padding: 4px 8px;
        color: #161615;
        border-radius: 4px;
        flex: 0 0 auto;

        &.badge-running {
          background-color: var(--negative);
        }

        &.badge-active {
          background-color: var(--primary);
        }
      }

      > .date {
        margin-left: auto;
        margin-right: 10px;
        color: var(--white-a50);
        font-size: 14px;
      }
    }
  }
  .home24-open-bottom {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 15px 0;

    a.f-link {
      font-size: 12px;
    }
  }
}
</style>